
<template>
    <div class="fb-page fb-page-index" data-href="https://www.facebook.com/WeddingSongsTWN/?fref=ts&amp;pnref=story" data-tabs="timeline" data-width="290" data-height="200" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true">
        <blockquote cite="https://www.facebook.com/WeddingSongsTWN/?fref=ts&amp;pnref=story" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/WeddingSongsTWN/?fref=ts&amp;pnref=story" target="_blink"></a></blockquote>
    </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'fanspage',
  data () {
    return {
      msg: ''
    }
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// Fanspage.vue?2a1606d3